import { jsx } from "react/jsx-runtime";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";
import { validateTidalLicense } from "../../base/index.js";
function PublishedWithChanges(props) {
  return /* @__PURE__ */ jsx(
    PublishedWithChangesIcon,
    {
      "data-testid": "PublishedWithChanges",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "PublishedWithChanges",
      "data-tidal-icon-meta": "miscellaneous"
    }
  );
}
PublishedWithChanges.tidalIconMeta = {
  categories: "miscellaneous",
  name: "PublishedWithChanges"
};
validateTidalLicense();
export {
  PublishedWithChanges
};
//# sourceMappingURL=PublishedWithChanges.js.map
